import { DateTime, Interval } from 'luxon';

import { LevelConfig, LevelEnum } from '@apps/pata/services/planning/timeline-constants';

export class TimelineCell
{
    public offsetPx: number;
    public width: number;
    public label: string;
    public title: string = '';
    private totalDays: number;

    constructor (dateTime: DateTime, levelConfig: LevelConfig, dayCellSize: number)
    {
        this.label = dateTime.toFormat(levelConfig.labelFormat);
        this.title = dateTime.toFormat(levelConfig.titleFormat);

        if (levelConfig.dtUnit === 'hour')
        {
            this.width = dayCellSize;
        }
        else
        {
            const since: DateTime = dateTime.startOf(levelConfig.dtUnit);
            const until: DateTime = dateTime.endOf(levelConfig.dtUnit).startOf('day');
            const minPeriod: DateTime = since.startOf('day');
            const maxPeriod: DateTime = until.plus({ day: 1 }).startOf('day');

            this.totalDays = Interval.fromDateTimes(minPeriod, maxPeriod).length('days');
            if (levelConfig.level == LevelEnum.Level1 && levelConfig.dtUnit === 'day')
            {
                this.width = 2 * dayCellSize;
            }
            else
            {
                this.width = this.totalDays * dayCellSize;
            }
        }
    }
}
